import { AbsenceResponse } from "../contracts/AbsenceResponse";
import { Absence } from "../models/Absence";

/** Maps absence responses from the API to frontend models. */
export class AbsenceResponseMapper {
  toAbsence = (response: AbsenceResponse): Absence => ({
    id: response.id,
    memberId: response.memberId,
    startDate: response.startDate,
    endDate: response.endDate,
    note: response.note ?? null,
    recordedBy: response.recordedBy,
    dateCreated: new Date(response.dateCreated),
    dateModified: new Date(response.dateModified),
  });

  toAbsences = (responses: AbsenceResponse[]): Absence[] => responses.map(this.toAbsence);
}
